import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  avatarSkeleton: {
    height: 130,
  },
  xsHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  contactContainer: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
    },
  },
  mb16: {
    [theme.breakpoints.up("md")]: {
      marginBottom: "16px",
    },
  },
}));

export default styles;
